import type { MobileCaptureSessionStatus } from '../mobileCaptureApi'

/** Active mobile-capture session metadata for picker completion polling. */
export type MobileCaptureSessionMeta = {
  sessionId: string
  createdAt: string
  status: MobileCaptureSessionStatus
}

export function isMobileCaptureSessionPaired(meta: MobileCaptureSessionMeta | null | undefined): boolean {
  return meta?.status === 'paired'
}

/** Picker items created strictly after the active session was issued. */
export function filterSessionScopedNewPickerIds<T extends { id: string; created_at: string | null }>(
  items: T[],
  knownIds: Set<string>,
  sessionCreatedAt: string,
): string[] {
  const sessionCreatedMs = new Date(sessionCreatedAt).getTime()
  if (!Number.isFinite(sessionCreatedMs)) return []
  return items
    .filter((item) => {
      if (knownIds.has(item.id)) return false
      if (!item.created_at) return false
      const createdMs = new Date(item.created_at).getTime()
      if (!Number.isFinite(createdMs)) return false
      return createdMs > sessionCreatedMs
    })
    .map((item) => item.id)
}
